'use client';

import { useAtomValue } from 'jotai';
import { useGameScenario } from '@/hooks/use-game-scenario';
import { usePollingInterval } from '@/hooks/use-polling-interval';
import { forceQuickPollingUntilAtom } from '@/store/polling-atoms';
import { useEffect, useState } from 'react';

/**
 * 全局轮询间隔控制器
 * Global polling interval controller
 *
 * 根据场景自动调整轮询间隔（优先级从高到低）：
 * Automatically adjusts polling interval based on scenario (priority from high to low):
 *
 * 1. 充值/提现后 3 分钟内：强制 5 秒（最高优先级）
 *    Within 3 minutes after deposit/withdrawal: force 5s (highest priority)
 * 2. 游戏中：5 秒 (In game: 5 seconds)
 * 3. 其他场景：10 秒 (Other scenarios: 10 seconds)
 */
export function PollingIntervalController() {
  const { isInGame } = useGameScenario();
  const forceQuickPollingUntil = useAtomValue(forceQuickPollingUntilAtom);
  const [now, setNow] = useState(Date.now());

  // 每秒检查一次强制快速轮询是否过期
  // Check every second if force quick polling has expired
  useEffect(() => {
    if (forceQuickPollingUntil > 0) {
      const timer = setInterval(() => {
        setNow(Date.now());
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [forceQuickPollingUntil]);

  // 优先级 1：检查是否在强制快速轮询期间（充值/提现后 3 分钟内）
  // Priority 1: Check if in force quick polling period (within 3 minutes after deposit/withdrawal)
  const isForceQuickPolling = forceQuickPollingUntil > now;

  // 优先级 2：游戏场景
  // Priority 2: Game scenario
  const shouldUseFastInterval = isForceQuickPolling || isInGame;

  // 强制快速轮询或游戏中 5秒，其他场景 10秒
  // Force quick polling or in game: 5s, other scenarios: 10s
  usePollingInterval(shouldUseFastInterval ? 5000 : 5000, [shouldUseFastInterval]); // 暂时两者都是 5000，保留原来逻辑避免后续有调整需求

  return null;
}
